import { Flex } from "~/components/Flex";
import { CreateTicketingIntegrationFirstStepIcon } from "~/images/tickets/CreateTicketingIntegrationFirstStepIcon";
import { Typography } from "@mui/material";
import { TicketsSilhouetteIcon } from "~/images/tickets/TicketsSilhouetteIcon";
import { CreateTicketingIntegrationThirdStepIcon } from "~/images/tickets/CreateTicketingIntegrationThirdStepIcon";
import React from "react";

export const CreateTicketingIntegrationContent = () => {
  return (
    <>
      <Flex flexDirection="column" maxWidth={232}>
        <CreateTicketingIntegrationFirstStepIcon
          sx={{ width: "100%", height: 144 }}
        />
        <Typography
          sx={{
            color: (theme) => theme.palette.text.secondary,
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          Set up an integration with the ticketing system of your choice.
        </Typography>
      </Flex>
      <Flex flexDirection="column" maxWidth={232}>
        <TicketsSilhouetteIcon
          sx={{ width: "100%", height: 144 }}
          hasStepNumber
        />
        <Typography
          sx={{
            color: (theme) => theme.palette.text.secondary,
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          Create tickets from any findings within Mondoo.
        </Typography>
      </Flex>
      <Flex flexDirection="column" maxWidth={232}>
        <CreateTicketingIntegrationThirdStepIcon
          sx={{ width: "100%", height: 144 }}
        />
        <Typography
          sx={{
            color: (theme) => theme.palette.text.secondary,
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          As you fix issues, seamlessly sync progress between Mondoo and your
          ticketing system.
        </Typography>
      </Flex>
    </>
  );
};
